import { QuestionMarkCircleIcon } from "@heroicons/react/outline";

import { useIsReadonly } from "@/components/PowerBlock/Block/readonly-context";
import { Toggle } from "@/components/Toggle";
import { Skeleton } from "@/components/ui/skeleton";
import { BasicTooltip } from "@/components/ui/Tooltip";

interface ApplyInputVariablesToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  isLoading?: boolean;
}

const ApplyInputVariablesToggle = ({
  enabled,
  onChange,
  isLoading = false,
}: ApplyInputVariablesToggleProps) => {
  const isReadonly = useIsReadonly();

  return (
    <div className="flex items-center justify-between pl-6">
      <div className="flex items-center gap-1">
        <span className="text-sm text-gray-700">Apply Input Variables</span>
        <BasicTooltip content="When enabled, input variable values are applied to the template placeholders. When disabled, returns template with placeholders like {variable_name}.">
          <QuestionMarkCircleIcon className="h-4 w-4 text-gray-400" />
        </BasicTooltip>
      </div>
      {isLoading ? (
        <Skeleton width={44} height={24} borderRadius={12} />
      ) : (
        <Toggle enabled={enabled} setEnabled={onChange} disabled={isReadonly} />
      )}
    </div>
  );
};

export default ApplyInputVariablesToggle;
